import { isOnboardingRequired } from "../../utils/auth/getlostAuthProvider";

/**
 * Routing decision for PhoneAuth.handleVerifyCode after Firebase phone
 * sign-in succeeds. Extracted from the React component so it can be
 * unit-tested without rendering.
 *
 *   - `hasEmail === false`     -> the user is phone-only. They must go
 *     through the email-collection form, which on completion will route
 *     to /onboarding if the backend has no users row.
 *   - `hasEmail === true` and the admin session rejects with a 404-shaped
 *     error (matched via isOnboardingRequired) -> /onboarding.
 *   - Otherwise (session established or non-fatal session error) ->
 *     continue to the authenticated dashboard.
 *
 * Source of truth: getlst/getlost-admin#111.
 */
export type PhoneVerifyRoute = "needsOnboarding" | "success";

export function decidePhoneVerifyNext(input: {
  hasEmail: boolean;
  sessionError: unknown;
}): { route: PhoneVerifyRoute } {
  if (!input.hasEmail) {
    return { route: "needsOnboarding" };
  }
  if (isOnboardingRequired(input.sessionError)) {
    return { route: "needsOnboarding" };
  }
  return { route: "success" };
}
